import { render, staticRenderFns } from "./zone-maincontact.vue?vue&type=template&id=122431f2&scoped=true"
import script from "./zone-maincontact.vue?vue&type=script&lang=js"
export * from "./zone-maincontact.vue?vue&type=script&lang=js"
import style0 from "./zone-maincontact.vue?vue&type=style&index=0&id=122431f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122431f2",
  null
  
)

export default component.exports